<template>
  <div
    class="w-100 bg-white hotel-filter-navbar"
    :class="{ 'active z-index-1039': showAsNavbar }">
    <div
      v-if="!isLoading"
      class="w-100"
      :class="{
        'ga-container fluid px-0 px-md-3': showAsNavbar,
      }">
      <div class="w-100 filter-outer">
        <div
          class="filter-container w-100 main d-flex flex-column flex-lg-row align-items-center position-relative"
          :class="{ 'z-index-1042': showBackdrop }">
          <div class="d-flex align-items-center w-100 filter-wrapper">
            <div class="stay-date filter-item">
              <CalendarRoom
                ref="calendarRoom"
                :opens="$is_mobile_view ? 'center' : 'right'"
                :date_default="stayDate"
                :filter_guest="guests"
                @togglePopup="toggleDatePopup"
                @finish="setStayDate"
                only_for_page="search-room"
                :is_double="!$is_mobile_view"
                wrapper_class="calendar-be-active calendar-be height-auto lh-1 align-top mt-3px w-100">
              </CalendarRoom>
            </div>
            <CustomDropdown
              v-model="showGuestPopup"
              full-width
              :min-width="285"
              class="filter-item guests">
              <template #trigger>
                <div class="d-flex align-items-center p-3 wrapper">
                  <svg
                    class="mr-2-5 icon"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.7597 7.76241C14.7597 10.4062 12.5963 12.5248 9.8967 12.5248C7.19806 12.5248 5.03367 10.4062 5.03367 7.76241C5.03367 5.11865 7.19806 3 9.8967 3C12.5963 3 14.7597 5.11865 14.7597 7.76241ZM2.54736 17.9174C2.54736 15.47 5.93289 14.8577 9.8967 14.8577C13.882 14.8577 17.246 15.4911 17.246 17.9404C17.246 20.3877 13.8605 21 9.8967 21C5.91136 21 2.54736 20.3666 2.54736 17.9174ZM16.7208 7.84875C16.7208 9.19506 16.3079 10.4513 15.5838 11.4948C15.5085 11.6021 15.575 11.7468 15.7061 11.7698C15.8881 11.7995 16.075 11.8177 16.2658 11.8216C18.164 11.8704 19.8676 10.6736 20.3382 8.87118C21.0359 6.19676 18.9889 3.79543 16.3813 3.79543C16.0985 3.79543 15.8274 3.82418 15.5632 3.87688C15.527 3.88454 15.4879 3.90179 15.4683 3.93246C15.4429 3.97174 15.4615 4.02253 15.4869 4.05607C16.2707 5.13216 16.7208 6.44206 16.7208 7.84875ZM19.8646 13.7023C21.1406 13.9466 21.9791 14.444 22.3265 15.1694C22.621 15.7635 22.621 16.4534 22.3265 17.0475C21.7952 18.1705 20.0809 18.5318 19.4145 18.6247C19.2766 18.6439 19.166 18.5289 19.1807 18.3928C19.5212 15.2805 16.8137 13.8048 16.1131 13.4656C16.0838 13.4493 16.0769 13.4263 16.0799 13.411C16.0818 13.4014 16.0946 13.3861 16.1171 13.3832C17.6327 13.3545 19.2629 13.5586 19.8646 13.7023Z"
                      fill="#999999" />
                  </svg>
                  <div class="w-100">
                    <p class="body-3 mb-0 label">Guests</p>
                    <p class="body-2-1 mb-0 value">{{ guestSummary }}</p>
                  </div>
                </div>
              </template>

              <template #content>
                <div class="w-100 px-3">
                  <GuestSelection
                    :default-data="guests"
                    @guest-change="updateGuest" />
                </div>
              </template>
            </CustomDropdown>
            <div class="filter-item promo-code position-relative">
              <div
                class="d-flex align-items-center px-3 wrapper"
                :class="
                  checkPromoCodeLoading || isPromoCodeNotAvailable
                    ? 'py-7px'
                    : 'py-3'
                ">
                <svg
                  class="mr-2-5 icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.399 9.146l.72.72c.571.56.881 1.32.881 2.12.01.8-.3 1.561-.86 2.13l-.01.01-.71.71c-.28.28-.44.66-.44 1.061v1.03c0 1.66-1.35 3.011-3.011 3.011h-1.03c-.4 0-.78.16-1.061.44l-.72.72c-.59.591-1.36.88-2.131.88-.77 0-1.54-.289-2.13-.869l-.73-.731c-.28-.28-.66-.44-1.061-.44h-1.03c-1.66 0-3.011-1.351-3.011-3.011v-1.03c0-.401-.16-.781-.44-1.071l-.72-.71c-1.17-1.17-1.18-3.081-.01-4.26l.73-.731c.28-.28.44-.66.44-1.07v-1.02c0-1.66 1.35-3.011 3.011-3.011h1.03c.4 0 .78-.161 1.06-.441l.721-.72c1.17-1.18 3.08-1.18 4.26-.01l.73.73c.28.28.66.44 1.06.44h1.03c1.66 0 3.011 1.35 3.011 3.011v1.031c0 .4.16.78.44 1.06ZM9.425 15.446c.24 0 .46-.09.62-.26l5.142-5.139c.34-.34.34-.901 0-1.241s-.891-.341-1.231 0l-5.142 5.14c-.34.34-.34.9 0 1.24.16.17.38.26.611.26Zm4.272-.88c0 .49.39.88.88.88.48 0 .87-.39.87-.88 0-.48-.39-.87-.87-.87s-.88.39-.88.87ZM9.435 8.556c.48 0 .87.39.87.87 0 .491-.39.88-.87.88s-.88-.389-.88-.88c0-.48.4-.87.88-.87Z"
                    fill="#999" />
                </svg>
                <div class="w-100">
                  <p class="body-3 mb-0 label">Promo Code</p>
                  <input
                    type="text"
                    class="w-100 border-0 body-2-1 promo-code-input p-0 d-block value"
                    style="padding-right: 28px !important"
                    placeholder="-"
                    v-model="promoCodeDisplay"
                    @focus="togglePromoCodeInput(true)"
                    @blur="togglePromoCodeInput(false)" />
                  <template v-if="$isNotEmptyV2(promoCodeDisplay)">
                    <p v-if="checkPromoCodeLoading" class="mb-0 body-3">
                      Checking promo code...
                    </p>
                    <p
                      v-if="isPromoCodeNotAvailable"
                      class="mb-0 body-3 text-danger">
                      Promo code is not available
                    </p>
                  </template>
                </div>
              </div>

              <div
                v-if="$isNotEmptyV2(promoCodeDisplay)"
                @click="setPromoCode()"
                class="position-absolute cursor-pointer label icon"
                style="right: 10px; bottom: 24px">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.8 6.21L17.39 4.8L11.8 10.39L6.21 4.8L4.8 6.21L10.39 11.8L4.8 17.39L6.21 18.8L11.8 13.21L17.39 18.8L18.8 17.39L13.21 11.8L18.8 6.21Z"
                    fill="#222222" />
                </svg>
              </div>
            </div>
          </div>
          <div class="filter-button">
            <state-button
              class="rounded py-12px ls-01 font-bold"
              variant="secondary"
              block
              :click="searchRoom">
              <svg
                class="mb-1"
                height="14"
                viewBox="0 0 33 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.25328 14.1087C5.25328 8.93402 9.46394 4.72469 14.6386 4.72469C19.8119 4.72469 24.0226 8.93402 24.0226 14.1087C24.0226 19.2834 19.8119 23.494 14.6386 23.494C9.46394 23.494 5.25328 19.2834 5.25328 14.1087ZM29.9133 28.054L23.7813 21.938C25.5893 19.83 26.6893 17.098 26.6893 14.1087C26.6893 7.46469 21.2826 2.05802 14.6386 2.05802C7.99327 2.05802 2.58661 7.46469 2.58661 14.1087C2.58661 20.754 7.99327 26.1607 14.6386 26.1607C17.3346 26.1607 19.8186 25.2594 21.8279 23.7567L28.0306 29.942L29.9133 28.054Z"
                  fill="#fff" />
              </svg>

              <span class="ml-1 filter-button-text">{{
                $t('hotel.search')
              }}</span>
            </state-button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showBackdrop"
      class="w-100 position-fixed z-index-1041 w-100"
      style="height: 100vh; background-color: #00000099; left: 0; top: 0"></div>
  </div>
</template>

<script>
import moment from 'moment';
import { get } from '@/services/index.js';
import { mapMutations, mapGetters } from 'vuex';
import CalendarRoom from '@/components/hotel/be/CalendarRoom';
import CustomDropdown from '../../general/CustomDropdown.vue';
import GuestSelection from './GuestSelection.vue';

export default {
  components: {
    CalendarRoom,
    CustomDropdown,
    GuestSelection,
  },
  data() {
    return {
      isLoading: true,
      stayDate: {
        startDate: moment().toDate(),
        endDate: moment().add(1, 'd').toDate(),
      },
      guests: {
        adult: 1,
        child: 0,
        infant: 0,
      },
      promoCode: '',
      checkPromoCodeLoading: false,
      isPromoCodeNotAvailable: false,
      showDatePopup: false,
      showGuestPopup: false,
      isPromoCodeInputActive: false,
      scrollPosition: 0,
    };
  },
  computed: {
    ...mapGetters(['getBeFilter', 'getMerchant']),
    showBackdrop() {
      return (
        this.showDatePopup || this.showGuestPopup || this.isPromoCodeInputActive
      );
    },
    guestSummary() {
      let text = Object.entries(this.guests)
        .filter(([key, value]) => value > 0)
        .map(([key, value]) => `${value} ${this.$pluralWord(value, key)}`);
      return text.join(', ');
    },
    promoCodeDisplay: {
      get() {
        return this.promoCode;
      },
      set(newValue) {
        this.promoCode = newValue.toUpperCase();
      },
    },
    savedPromoCode() {
      return this.getBeFilter.promo_code;
    },
    showAsNavbar() {
      const showPosition = this.$is_mobile_view ? 600 : 700;
      return this.scrollPosition > showPosition && !this.showBackdrop;
    },
  },
  watch: {
    showGuestPopup() {
      if (this.showGuestPopup && this.showDatePopup) {
        this.$refs.calendarRoom.toggleCalendar();
      }
    },
    savedPromoCode() {
      this.setPromoCode(this.savedPromoCode);
    },
    showBackdrop() {
      this.$smoothScroll('search-room-middle');
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.fillSavedData();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapMutations(['setBeFilter', 'setSpecificBeFilter']),
    fillSavedData() {
      this.isLoading = true;
      const { check_in, check_out } = this.$deepCopy(this.getBeFilter.date);
      this.stayDate = {
        startDate: moment(check_in).toDate(),
        endDate: moment(check_out).toDate(),
      };
      this.guests = this.$deepCopy(this.getBeFilter.guest);
      this.promoCode = this.getBeFilter.promo_code;
      this.validateDate();
      this.isLoading = false;
    },
    validateDate() {
      const TODAY = this.$startDate();
      const { check_in, check_out } = this.getBeFilter.date;
      const savedCheckinStart = this.$startDate(check_in);

      if (moment(savedCheckinStart).isSameOrAfter(TODAY)) return;

      this.stayDate.startDate = moment().toDate();

      const savedCheckoutStart = this.$startDate(check_out);
      if (moment(savedCheckoutStart).isSameOrBefore(TODAY)) {
        const DEFAULT_NIGHT = this.$defaultFilterBE('night');
        this.stayDate.endDate = moment().add(DEFAULT_NIGHT, 'd').toDate();
      }

      const { startDate, endDate } = this.stayDate;
      const params = [
        { key: 'date', value: { check_in: startDate, check_out: endDate } },
      ];
      this.setSpecificBeFilter(params);
    },

    updateGuest(guests) {
      this.guests = guests;
    },
    toggleDatePopup(show) {
      this.showDatePopup = show;
    },
    togglePromoCodeInput(active) {
      this.isPromoCodeInputActive = active;
    },
    setStayDate(updatedDate) {
      this.stayDate = updatedDate;
    },
    async searchRoom() {
      try {
        if (this.$isNotEmptyV2(this.promoCode)) await this.checkingPromoCode();

        const { startDate: check_in, endDate: check_out } = this.stayDate;
        const params = {
          date: { check_in, check_out },
          guest: this.$deepCopy(this.guests),
          promo_code: this.promoCode,
        };
        this.setBeFilter(params);

        setTimeout(() => {
          this.$emit('search');
        }, 100);
      } catch (error) {
        console.log('ERROR in searchRoom() :', error.message);
      } finally {
        return Promise.resolve();
      }
    },
    async checkingPromoCode() {
      try {
        this.checkPromoCodeLoading = true;
        this.isPromoCodeNotAvailable = false;
        const { startDate, endDate } = this.stayDate;
        const apiParams = {
          merchant_id: this.getMerchant.id,
          check_in_date: this.$formatDateApi(startDate),
          check_out_date: this.$formatDateApi(endDate),
          promo_code: this.promoCode,
        };

        const apiResponse = await get(
          'CORE_HOTEL',
          'promocode-detail',
          apiParams
        );
        const { success, data, message } = apiResponse.data;
        if (!success) throw new Error(message);

        this.checkPromoCodeLoading = false;
      } catch (error) {
        console.log('ERROR in checkingPromoCode() : ', error.message);
        this.isPromoCodeNotAvailable = true;
        this.checkPromoCodeLoading = false;
        throw error;
      }
    },
    setPromoCode(newPromoCode = '') {
      this.promoCode = newPromoCode;
      this.checkPromoCodeLoading = false;
      this.isPromoCodeNotAvailable = false;
    },
    handleScroll() {
      this.scrollPosition = window.scrollY || window.pageYOffset;
    },
  },
};
</script>
<style>
.hotel-filter-navbar {
  position: relative;
  transition: transform 0.3s ease, top 0.3s ease;
}
.hotel-filter-navbar.active {
  position: fixed;
  top: 75.5px;
  left: 0px;
  transform: translateY(-100%);
  animation: slideDown 0.3s ease forwards;
}
.hotel-filter-navbar .filter-outer {
  background-color: #fff;
}
.hotel-filter-navbar.active .filter-outer {
  background-color: var(--merchant-button-color) !important;
  padding: 0.5rem;
  border-radius: 0px 0px 4px 4px;
}
.filter-container {
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
}
.hotel-filter-navbar.active .filter-container {
  -ms-flex-direction: row !important;
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: normal !important;
  flex-direction: row !important;
}
.filter-wrapper {
  border: 1px solid #ccc;
  flex-wrap: wrap;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 10px 20px 0px;
  background-color: #fff;
  margin-bottom: 1rem;
}
.hotel-filter-navbar.active .filter-wrapper {
  flex-wrap: nowrap !important;
  margin-bottom: 0px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border: none !important;
}
.hotel-filter-navbar.active .filter-item {
  flex: 1 1 auto !important;
  max-width: 33.333% !important;
  min-width: 0;
}
.hotel-filter-navbar.active .filter-item .wrapper {
  padding: 8px !important;
}
.hotel-filter-navbar.active .filter-item .icon {
  display: none !important;
}
.hotel-filter-navbar.active .filter-item .label {
  font-size: 10px !important;
}
.hotel-filter-navbar.active .filter-item .value {
  font-size: 12px !important;
}
.filter-item.stay-date {
  flex: 0 0 100%;
  max-width: 100%;
  border-bottom: 1px solid #dee2e6;
}
.hotel-filter-navbar.active .filter-item:not(.promo-code) {
  border-right: 1px solid #dee2e6;
  border-bottom: none !important;
}
.filter-item.guests {
  border-right: 1px solid #dee2e6;
}
.filter-item.guests,
.filter-item.promo-code {
  flex: 0 0 50%;
  max-width: 50%;
}
.hotel-filter-navbar.active input.promo-code-input {
  max-width: auto !important;
  line-height: 15px !important;
}
input.promo-code-input {
  max-width: 150px;
  line-height: 21px;
}
input.promo-code-input:focus {
  border: none !important;
}
.py-7px {
  padding-block: 7px;
}
.filter-button {
  width: 100%;
}
.hotel-filter-navbar.active .filter-button {
  width: auto !important;
  padding: 4px;
  background-color: #fff;
  border-radius: 0px 4px 4px 0px;
}
.hotel-filter-navbar.active .filter-button .rounded {
  padding: 10px 16px !important;
}
.hotel-filter-navbar.active .filter-button-text {
  display: none;
}
@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
@media screen and (min-width: 768px) {
  .hotel-filter-navbar.active {
    top: 86.5px;
  }
}
@media screen and (min-width: 992px) {
  .filter-container {
    border: 1px solid #dee2e6 !important;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 10px 20px 0px;
    border-radius: 4px;
    background-color: #fff;
    -ms-flex-direction: row !important;
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    flex-direction: row !important;
  }
  .filter-wrapper {
    border: none;
    margin-bottom: 0px;
    /* border-radius: 4px; */
    box-shadow: none;
  }
  .filter-item {
    border-right: 1px solid #dee2e6 !important;
  }
  .filter-item.stay-date {
    border-bottom: none;
  }
  .filter-item:not(.promo-code) {
    flex: 1 1 auto;
    max-width: 100%;
  }
  .filter-item.promo-code {
    width: 220px;
    flex: none;
  }
  .filter-button {
    width: 200px;
    padding-inline: 1rem;
  }
  .hotel-filter-navbar.active .filter-button {
    width: 160px !important;
    padding-inline: 8px;
  }
  .hotel-filter-navbar.active .filter-button-text {
    display: inline;
  }
  .hotel-filter-navbar.active .filter-item .label {
    font-size: 12px !important;
  }
  .hotel-filter-navbar.active .filter-item .value {
    font-size: 14px !important;
  }
  .hotel-filter-navbar.active .filter-item:not(.stay-date) .value {
    line-height: 22px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/HotelRoomFilter.vue